._button_1cnib_1 {
  position: fixed;
  bottom: 18px;
  right: 30px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
  z-index: 2; }

._buttonWithPimple_1cnib_9:after {
  position: absolute;
  border-radius: 50%;
  display: block;
  content: ' ';
  width: 12px;
  height: 12px;
  top: calc(-12px / 3);
  right: calc(-12px / 3);
  background-color: #116dff; }
